import React from 'react';
import { Search } from 'lucide-react';
import { Customer } from '../../../types';

interface ProjectFiltersProps {
  customers: Customer[];
  selectedCustomer: number | '';
  searchQuery: string;
  onCustomerChange: (value: number | '') => void;
  onRefresh: () => void;
  onSearchChange: (value: string) => void;
}

const ProjectFilters: React.FC<ProjectFiltersProps> = ({
  customers,
  selectedCustomer,
  searchQuery,
  onCustomerChange,
  onRefresh,
  onSearchChange,
}) => (
  <>
    <div className="flex flex-wrap gap-2 items-end mb-3">
      <div>
        <label className="block text-sm font-medium mb-0.5 theme-text-primary">ClientTRAC</label>
        <select
          className="border border-white  theme-border rounded-lg p-2  focus:outline-none focus:border-blue-500 focus:ring-0  theme-bg-primary theme-text-primary"
          value={selectedCustomer}
          onChange={(e) => onCustomerChange(e.target.value ? Number(e.target.value) : '')}
        >
          <option value="">All</option>
          {customers.map((c) => (
            <option key={c.id} value={c.id}>{c.item}</option>
          ))}
        </select>
      </div>
      <button
        onClick={onRefresh}
        className="px-4 py-2 rounded-lg theme-bg-secondary theme-border hover:opacity-80 transition-colors theme-text-primary custom-button"
      >
        Refresh
      </button>
    </div>

    {/* Search Bar */}
    <div className="mb-3">
      <div className="relative">
        <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 theme-text-tertiary w-4 h-4" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by job name, job code, client name, or client ID..."
          className="w-full pl-10 pr-4 py-2 theme-border rounded-lg border border-white  theme-border rounded-lg p-2  focus:outline-none 
         focus:border-blue-500 
  focus:ring-0  theme-bg-primary theme-text-primary  border border-white theme-bg-primary theme-text-primary"
        />
      </div>
    </div>
  </>
);

export default ProjectFilters;
